import {Component, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SwitchBoard} from "../services/SwitchBoard";
import {takeUntil} from "rxjs/operators";
import {Session} from "../services/Session";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-global-floating-window',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './global-floating-window.component.html',
  styleUrl: './global-floating-window.component.scss'
})
export class GlobalFloatingWindowComponent {
  displayWidget = false;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  isMinimized = false;
  isMaximized = false;
  title = '';
  customPopupStyle: any;
  customMinimizeStyle: any;
  popupStyle: any = {
    height: '60vh',
    right: '60px',
    bottom: 0,
    width: '55vw',
    noPadding: false
  };
  smallScreenStyle: any = {
    height: '60vh',
    right: '60px',
    top: '40vh',
    bottom: 0,
    width: '55vw',
    noPadding: false
  };
  minimizeStyle: any = {
    height: '60vh',
    right: '60px',
    bottom: 0,
    width: '55vw',
    noPadding: false
  };
  maximizeStyles: any = {
    height: '90vh',
    width: '90vw',
    top: '5vh',
    right: '5vw'
  };
  headerStyle: any = {
    backgroundColor: '#16477a',
    color: '#fff',
    padding: '12px 25px',
  };
  hideMaximize = false;
  currentView = 'maximized';
  clientsView = false;
  showScrollBar = true;

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private switchBoard: SwitchBoard
  ) {
    this.switchBoard.onPostTabsChange.pipe(takeUntil(this.destroy$))
      .subscribe(tab => {
        if (tab.companyId && tab.companyId !== '') {
          this.switchPostsTab(tab);
        } else {
          this.showScrollBar = tab.showScroll;
        }
      });
  }

  switchPostsTab(tab) {
    const orgPreferences: any = Session.get('org_Preferences');
    this.clientsView = orgPreferences.clientView || false;
    let link;
    if (tab.taskId) {
      if (this.clientsView) {
        link = ['channels', 'clients' , tab.companyId , 'posts', tab.activeTab, tab.taskId];
      } else {
        link = ['channels', 'companies', tab.companyId , 'posts', tab.activeTab, tab.taskId];
      }
    } else {
      if (this.clientsView) {
        link = ['channels', 'clients' , tab.companyId , 'posts', tab.activeTab];
      } else {
        link = ['channels', 'companies', tab.companyId , 'posts', tab.activeTab];
      }
    }
    this.switchBoard.onDisplayFloatingWindow.next({
      url: link,
      // title: `Create Invoice: ${$event.name}`,
      title: tab.title,
      initialView: 'maximized',
      maxmizeStyle: {
        height: '90vh',
        width: '90vw'
      }
    });
    this.showScrollBar = tab.showScroll;
  }

  ngOnInit(): void {
    this.switchBoard.onSetPopupTitle.subscribe(title => {
      this.title = title ? title : this.title;
    });
    this.switchBoard.onDisplayFloatingWindow
      .subscribe(data => {
        this.showScrollBar = true;
        if (this._router.url.includes('/stickynotes') && data.closeSticky) {
          this.displayWidget = false;
          this.title = '';
        } else if (data.url && data.url.length > 0) {
          this.displayWidget = true;
          this.resetSettings();
          this.title = data.title;
          data.url.unshift('modal');
          this.applyCSS(data);
          if (data.hideMaximize) {
            this.hideMaximize = data.hideMaximize;
          }
          this._router.navigate([{outlets: {popup: data.url}}]);
        } else {
          this.displayWidget = false;
          this.title = '';
          this._router.navigate([{outlets: {popup: null}}]);
        }
      });
  }

  applyCSS(data) {
    if (data.initialView && data.initialView === 'maximized') {
      this.currentView = 'maximized';
    }
    this.customPopupStyle = data.popupStyle;
    this.customMinimizeStyle = data.minimizeStyle;
    if (this.customPopupStyle){
      this.currentView = 'smallscreen';
    }
    const tempPopupStyle = data.popupStyle || {};
    this.minimizeStyle.height = tempPopupStyle.height ? tempPopupStyle.height : this.minimizeStyle.height;
    this.minimizeStyle.width = tempPopupStyle.width ? tempPopupStyle.width : this.minimizeStyle.width;
    this.minimizeStyle.top = tempPopupStyle.top ? tempPopupStyle.top : this.minimizeStyle.top;
    this.minimizeStyle.right = tempPopupStyle.right ? tempPopupStyle.right : this.minimizeStyle.right;
    this.minimizeStyle.bottom = tempPopupStyle.bottom ? tempPopupStyle.bottom : this.minimizeStyle.bottom;
    this.minimizeStyle.noPadding = tempPopupStyle.noPadding;

    this.popupStyle.height = tempPopupStyle.height ? tempPopupStyle.height : this.getStyle('height');
    this.popupStyle.width = tempPopupStyle.width ? tempPopupStyle.width : this.getStyle('width');
    this.popupStyle.top = tempPopupStyle.top ? tempPopupStyle.top : this.getStyle('top');
    this.popupStyle.right = tempPopupStyle.right ? tempPopupStyle.right : this.getStyle('right');
    this.popupStyle.bottom = tempPopupStyle.bottom ? tempPopupStyle.bottom : this.getStyle('bottom');
    this.popupStyle.noPadding = tempPopupStyle.noPadding;

    const headerStyle = data.headerStyle || {};
    this.headerStyle.backgroundColor = headerStyle.backgroundColor ? headerStyle.backgroundColor : this.headerStyle.backgroundColor;
    this.headerStyle.color = headerStyle.color ? headerStyle.color : this.headerStyle.color;
    this.headerStyle.padding = headerStyle.color ? headerStyle.padding : this.headerStyle.padding;
  }

  getStyle(styleType){
    return this.currentView != 'maximized' ? this.popupStyle[styleType] : this.maximizeStyles[styleType];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeFloatingWindow() {
    this.displayWidget = false;
    this.switchBoard.closeAllTabs.next(true);
    this._router.navigate([{outlets: {popup: null}}]);
  }

  resetSettings() {
    this.isMaximized = false;
    this.isMinimized = false;
    this.title = '';
    this.popupStyle = {
      height: '60vh',
      right: '60px',
      bottom: 0,
      width: '55vw'
    };
    this.headerStyle = {
      backgroundColor: '#16477a',
      color: '#fff'
    };
    this.minimizeStyle = {
      height: '60vh',
      right: '60px',
      bottom: 0,
      width: '55vw',
      noPadding: false
    };
    this.hideMaximize = false;
  }

  minimizeWindow() {
    this.isMaximized = false;
    this.isMinimized = !this.isMinimized;
  }

  maximizeWindow() {
    this.isMinimized = false;
    this.isMaximized = true;
    this.popupStyle.height = this.maximizeStyles.height ? this.maximizeStyles.height : this.popupStyle.height;
    this.popupStyle.width = this.maximizeStyles.width ? this.maximizeStyles.width : this.popupStyle.width;
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  resizeWindow(viewToDisplay){
    this.currentView = viewToDisplay;
    if (this.customPopupStyle){
      this.popupStyle = this.customPopupStyle;
      this.minimizeStyle = this.customMinimizeStyle ? this.customMinimizeStyle : this.minimizeStyle;
    } else if (this.currentView == 'smallscreen'){
      this.popupStyle = this.smallScreenStyle;
    } else if (this.currentView == 'maximized'){
      this.popupStyle = this.maximizeStyles;
    }
  }

  toggleWindow(){
    if (this.customPopupStyle){
      this.popupStyle = this.customPopupStyle;
      this.minimizeStyle = this.customMinimizeStyle ? this.customMinimizeStyle : this.minimizeStyle;
    } else if (this.currentView == 'maximized'){
      this.currentView = 'smallscreen';
      this.popupStyle = this.smallScreenStyle;
    } else {
      this.currentView = 'maximized';
      this.popupStyle = this.maximizeStyles;
    }
  }
}
